import React from 'react'
import useConnectors from '../../../hooks/useConnectors'

export default function NbConnector({chargePointId}:{chargePointId: string}) {
    const {getAllConnectorsQuery} = useConnectors({chargePointId})

    if (getAllConnectorsQuery.isLoading) {
        return <>...</>
    }
    if (getAllConnectorsQuery.isError) {
        return <>-</>
    }
  return (
    <>
        {getAllConnectorsQuery.data?.pagination.total_count}
    </>
  )
}
